'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var USES = exports.USES = ['default', 'enclosed', 'flush', 'header', 'toolbar'];

var isContained = exports.isContained = function isContained(use) {
  return use === 'enclosed' || use === 'flush' || use === 'toolbar';
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.2644/js/nav/utils/tabUtils.js
// module id = 529
// module chunks = 3 4